import { render, staticRenderFns } from "./LeftNavigation.vue?vue&type=template&id=709a72ea&scoped=true&"
import script from "./LeftNavigation.vue?vue&type=script&lang=js&"
export * from "./LeftNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a72ea",
  null
  
)

export default component.exports